var fn = function( obj ){
var __t,__p='';
__p+='#pragma SLOT version\n\n#pragma SLOT definitions\n\n#pragma SLOT precision\n\n'+
( require( "@/webgl/glsl/includes/glsl-compat.frag" )() )+
'\n\n#pragma SLOT pf\n\nvoid main(void){\n\n  #pragma SLOT f\n  FragColor = vec4( 1.0 );\n\n}\n';
return __p;
};
fn.toString=fn;
module.exports = fn;